import {BaseModel} from '../base/base.model';
import {UsersModel} from '../users/users.model';
import {PricingsModel} from '../pricings/pricings.model';

export class DebtLogModel extends BaseModel {
    action_time?: number = 0;
    action_time_string?: number = 0;
    amount?: number = 0;
    client_debt_id?: number = 0;
    id?: number = 0;
    is_voided?: number = 0;
    reason?: string = '';
    transaction? = <DebtTransactionModel> {};
    transaction_id?: number = 0;
    user?: UsersModel;
    user_id?: number = 0;
    voided?: number = 0;
    voided_by?: number = 0;
    voided_reason?: number = 0;
    with_tags? = <DebtTransactionModel> {};
}

export class DebtLogTagsItemsModel extends BaseModel {
    name: string = '';
}


export class DebtChargeModel extends BaseModel {
    id?: number = 0;
    client_debt_id?: number = 0;
    amount?: number = 0;
    title?: number = 0;
    reason?: number = 0;
    user_id?: number = 0;
    user?: UsersModel;
    action_time?: number = 0;
    action_time_string?: string = '';

    payment_date?: number = 0;
    payment_date_string?: string = '';

    voided_log_id?: number = 0;
    payment_id?: number = 0;
    payment_type?: number = 0;
    payment_tries?: number = 0;
    charge_type?: number = 0;

    has_payment = false;
}

export class DebtPaymentModel extends BaseModel {
    id?: number = 0;
    client_debt_id?: number = 0;
    amount?: number = 0;
    reason?: number = 0;
    user?: UsersModel;
    user_id?: number = 0;
    action_time?: number = 0;
    action_time_string?: string = '';
    payment_date?: number = 0;
    payment_date_string?: string = '';
    voided?: number = 0;
    voided_reason?: number = 0;
    voided_b?: number = 0;
    is_voided = false;
}

export class DebtTransactionModel extends BaseModel {
    id?: number = 0;
    transaction_type?: string = '';
    amount?: number = 0;
    currency?: string = '';
    yodlee_transaction_id?: string = '';
    when_saved?: number = 0;
    description?: string = '';
    simple_description?: string = '';
    transaction_type_desc?: string = '';
    merchant_name?: string = '';
    post_date?: string = '';
    category?: number = 0;
    status?: number = 0;
    account?: number = 0;
    account_id?: number = 0;
    client_id?: number = 0;
    client_account_id?: number = 0;
    processed?: number = 0;
    processed_by?: number = 0;
    processed_amount?: number = 0;
    debt_log_id?: number = 0;
    account_balance?: number = 0;
    account_balance_currency?: string = '';
    accountNumber?: number = 0;
    voided_count?: number = 0;
    from_cdn?: number = 0;
    manual_transaction?: number = 0;
    post_date_int?: number = 0;
    check_digest?: number = 0;
    dup_of?: number = 0;
    dup_of_yodlee_id?: number = 0;
    from_bankparser?: number = 0;
    from_fd?: number = 0;
    tags? = <DebtLogTagsItemsModel[]> [];
}


export class DebtsModel extends BaseModel {
    id?: number = 0;
    client_id?: number = 0;
    pricing_id?: number = 0;
    percentage?: number = 0;
    total_debt?: number = 0;
    total_paid?: number = 0;
    created_time?: number = 0;
    creator_id?: number = 0;
    closed_time?: number = 0;
    closed_by?: number = 0;
    client_account_id?: number = 0;
    funded?: number = 0;
    funded_by?: number = 0;
    comissioned_to?: number = 0;
    comissioned_amount?: number = 0;
    comissioned_by?: number = 0;
    comissioned?: number = 0;
    ready_to_be_comissioned?: number = 0;
    balance?: number = 0;
    close_reason?: number = 0;
    speed: number = 0;
    status?: number = 0;
    is_closed? = false;
    funded_user? = <UsersModel> {};
    is_funded? = false;
    funded_date? = '';
    totaledDebt? = 0;

    pricing? = <PricingsModel> {};

    log = <DebtLogModel[]> [];
    payment = <DebtPaymentModel[]> [];
    charge = <DebtChargeModel[]> [];

}

export class TimelineSpeedModel extends BaseModel {
    value: number = 0;
    string: string = '';
}

export class TimelineModel extends BaseModel {
    type?: string = '';
    id?: number = 0;
    transaction?: string = '';
    true_amount?: string = '';
    transaction_amount?: number = 0;
    float_amount?: number = 0;
    date?: string = '';
    amount?: number = 0;
    action_time?: number = 0;
    user?: UsersModel;
    reason?: number = 0;
    is_voided?: boolean = false;
    tags?: string = '';
    events?: string = '';
    batch_date?: string = '';
    speed? = <TimelineSpeedModel> {};
    balance?: number = 0;

}

export class AccountStatusesModel extends BaseModel {
    id?: number = 0;
    name?: string = '';
    funded?: number = 0;
}

export enum SpeedModel {
    SLOW = <any> "Slow",
    STANDARD = <any> "Standard",
    FAST = <any> "Fast"
}

export class SpeedDatesModel extends BaseModel {
    start: string = "";
    finish: string = "";
}

export class TransactionModel extends BaseModel {

}

export class AddTransactionModel {
    account_id: number;
    amount: number;
    client_id: number;
    date?: any;
}

export class CloseReasonsModel {
    public static reasons = ['BANKRUPTCY', 'SETTLEMENT', 'REPEAT', 'REPAID']
}


// WEBPACK FOOTER //
// ./src/app/models/debts/debts.model.ts